import { render, staticRenderFns } from "./FormCrearProveedor.vue?vue&type=template&id=47e0074a&scoped=true&"
import script from "./FormCrearProveedor.vue?vue&type=script&lang=ts&"
export * from "./FormCrearProveedor.vue?vue&type=script&lang=ts&"
import style0 from "./FormCrearProveedor.vue?vue&type=style&index=0&id=47e0074a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e0074a",
  null
  
)

export default component.exports